<template>
	<div class="sa-planning">
		<div class="sa-planning-header">
			<b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Teleconsulto" @click="onClickPreviousDay()">
				<i class="fas fa-chevron-left"></i>
			</b-button>
			<span class="sa-planning-range-label">Dal {{ formatDate(dataDal) }} al {{ formatDate(dataAl) }}</span>
			<b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Teleconsulto" @click="onClickNextDay()">
				<i class="fas fa-chevron-right"></i>
			</b-button>
		</div>
		<div class="sa-planning-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="getFields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(area)="row">
						<div style="display: none">{{ (slot = getArea(row)) }}</div>
						<div>
							<span style="display: block; font-weight: 700">{{ slot.area }}</span>
							<span style="display: block; font-style: italic">Data Inizio: {{ formatDate(slot.dataInizio) }}</span>
							<span style="display: block; font-style: italic">Data Fine: {{ formatDate(slot.dataFine) }}</span>
						</div>
					</template>
					<template #cell()="row">
						<div style="display: none">{{ (slots = getDettaglioAttivita(row)) }}</div>
						<!-- <div v-for="slot in slots" :key="slot.id" :class="getClassByStato(slot.stato)" :style="{ backgroundColor: slot.areaColor }">{{ "Ora: " + slot.oraProgrammata }}</div> -->
						<div v-for="slot in slots" :key="slot.id" :class="getClassByStato(slot.stato)">
							<span class="sa-planning-body-activiti-name">{{ slot.nomeAttivita }}</span
							>{{ "Ora: " + slot.oraProgrammata }}
						</div>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-planning-footer"></div>
	</div>
</template>

<script>
import UtilityMixin from "../UtilityMixin";
import moment from "moment";
export default {
	mixins: [UtilityMixin],
	// computed: {
	// 	headers() {
	// 		return ["Attivita", 1, 2, 3, 4, 5, 6];
	// 	},
	// },
	data() {
		return {
			currentPage: 1,
			perPage: 10000000,
			listKey: 0,
			dataDal: null,
			dataAl: null,
			pathResource: "/rsaplanning",
			planningFilter: { dataRiferimento: null },
			idAccettazione: null,
			items: [],
		};
	},

	mounted() {
		this.idAccettazione = this.$route.query.idAccettazione;
		if (this.idAccettazione) {
			this.planningFilter.idAccettazione = this.idAccettazione;
		}
		this.changeRange();
	},
	computed: {
		getFields() {
			let fields = [
				{
					label: "Area",
					key: "area",
					sortable: true,
					//thStyle: "width: 7rem",
				},
			];
			let dataInizio = this.dataDal;
			let dataFine = this.dataAl;
			let contatore = 1;
			while (dataInizio <= dataFine) {
				fields.push({
					label: moment(dataInizio).format("ddd DD MMMM"),
					key: "slot" + contatore,
					sortable: false,
					slotDateValue: dataInizio,
					//thStyle: "width: 7rem",
				});
				dataInizio = dataInizio + 86400000;
				contatore++;
			}
			return fields;
		},
	},
	methods: {
		getWeekRowClass(index) {
			if (index === 0) {
				return "sa-planning-week-row sa-planning-week-header";
			} else {
				return "sa-planning-week-row-body";
			}
		},
		getClassByStato(stato) {
			return "sa-stato-" + stato.toLowerCase().replace(" ", "-");
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");

			UtilityMixin.methods.loadDataResources(me.pathResource, me.planningFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		getArea(row) {
			let slot = { area: row.item.area, dataInizio: row.item.dataInizio, dataFine: row.item.dataFine };
			return slot;
		},
		getDettaglioAttivita(row) {
			let slot = [];

			row.item.attivitaSchedulate.forEach((element) => {
				let dataSlot = moment(row.field.slotDateValue).format("DD/MM/YYYY");
				let dataAttivita = moment(element.dataOraProgrammata).format("DD/MM/YYYY");

				if (dataSlot === dataAttivita) {
					slot.push({ id: self.crypto.randomUUID(), nomeAttivita: element.nomeAttivita, stato: element.stato, area: row.item.area, oraProgrammata: moment(element.dataOraProgrammata).format("HH:mm") });
				}
			});

			return slot;
		},
		onClickPreviousDay() {
			let dataDal = this.dataDal - 86400000;
			this.changeRange(dataDal);
		},
		onClickNextDay() {
			let dataDal = this.dataDal + 86400000;
			this.changeRange(dataDal);
		},
		changeRange(dataDal) {
			this.dataDal = dataDal ? dataDal : new Date().getTime();
			this.dataAl = this.dataDal + 6 * 86400000;
			this.planningFilter.dataRiferimento = this.dataDal;
			this.loadData();
		},
	},
};
</script>

<style></style>
